import { useTranslation } from 'react-i18next';

export const useLocaleCodeIsoNorma = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  if (lang === 'cs') return 'cs-CZ';
  if (lang === 'sk') return 'sk-SK';
  if (lang === 'en') return 'en-GB';
  return 'cs-CZ';
};
